import React, { useState } from 'react';

import 'antd/lib/tabs/style/index.css';
import 'antd/lib/table/style/index.css';
import 'antd/lib/pagination/style/index.css';
import 'antd/lib/input/style/index.css';
import 'antd/lib/button/style/index.css';
import 'antd/lib/popover/style/index.css';
import 'antd/lib/spin/style/index.css';
import 'antd/lib/select/style/index.css';
import 'antd/lib/grid/style/index.css';
import 'antd/lib/form/style/index.css';
import 'antd/lib/space/style/index.css';
import 'antd/lib/switch/style/index.css';
import 'antd/lib/tooltip/style/index.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { Formik, Form, Field } from 'formik';
import axios from 'axios';
import { useDispatch } from 'react-redux';
import * as Route from '../../main/utils/serverRoutes';

import Button from '../../main/components/Button';
import Input from '../../onboarding/signUp/Input';
import { ALERT_TYPES } from '../../main/utils/const';

const pageCount = 2;

const prepareValues = ({ projectName }) => {
  return {
    bmc: {
      name: projectName,
    },
  };
};

export const CreateFirstBmc = ({
  locales,
  locales: { onboarding: pageLocales },
}) => {
  // TODO: This has copied and pasted code from elsewhere in teh app, pulling in components from other app spaces
  // This really needs a refactor, it's just a single huge component rather than breaking it out... hopefully we can allocate the time
  const [step, setStep] = useState(1);

  const {
    alert: { addAlert },
  } = useDispatch();

  return (
    <>
      <p className="sign-up-form-section__step-counter">
        {pageLocales.common.step} {step} {pageLocales.common.of} {pageCount}
      </p>
      <div className="sign-up-form-section__step-dots">
        {new Array(2).fill(1).map((_, index) => (
          <div
            key={index}
            className={`sign-up-form-section__step-dots-item ${
              index < step ? 'active' : ''
            }`}
            onClick={() => setStep(index + 1)}
          />
        ))}
      </div>

      <Formik
        initialValues={{ projectName: '' }}
        onSubmit={(values) => {
          axios
            .post(Route.bmcs(), prepareValues(values))
            .then((response) => {
              let redirect;
              if (values.haveBusinessIdea) {
                redirect = `/bmcs/${response.data.data.id}`;
              } else {
                redirect = `/bmcs/${response.data.data.id}/ideation`;
              }

              window.location = redirect;
            })
            .catch((error) => {
              setStep(1);
              if (error.response.status === 403) {
                addAlert({
                  id: 403,
                  type: ALERT_TYPES.warning,
                  title: error.response.data.errors.join(' '),
                });
              }
            });
        }}
      >
        {({ setFieldValue, submitForm }) => {
          const completeForm = (haveBusinessIdea) => {
            setFieldValue('haveBusinessIdea', haveBusinessIdea);
            submitForm();
          };
          return (
            <Form className="sign-up-form">
              {step === 1 && (
                <>
                  <h3 className="sign-up-form__title margin-bottom-10">
                    {pageLocales.titles.step2}
                  </h3>
                  <p className="sign-up-form__description">
                    {pageLocales.descriptions.step2}
                  </p>
                  <Field
                    locales={locales}
                    name="projectName"
                    component={Input}
                    placeholder={pageLocales.inputPlaceholders.projectName}
                    className="margin-bottom-20"
                  />
                  <Button
                    type="button"
                    className="w-full border border-light-gray"
                    variant="secondary"
                    onClick={() => setStep(2)}
                  >
                    {pageLocales.buttons.createProject}
                  </Button>
                </>
              )}
              {step === 2 && (
                <>
                  <h3 className="sign-up-form__title">
                    {pageLocales.titles.step4}
                  </h3>
                  <div className="sign-up-form__row">
                    <Button
                      type="button"
                      className="border border-light-gray bg-transparent text-black hover:bg-[#F3F4F6]"
                      id="button-no"
                      variant="secondary"
                      onClick={() => {
                        completeForm(false);
                      }}
                    >
                      {pageLocales.buttons.helpCreate}
                    </Button>
                    <Button
                      type="button"
                      id="button-yes"
                      className="border border-light-gray bg-transparent hover:bg-[#F3F4F6]"
                      variant="secondary"
                      onClick={() => {
                        completeForm(true);
                      }}
                    >
                      {pageLocales.buttons.iHave}
                    </Button>
                  </div>
                </>
              )}
            </Form>
          );
        }}
      </Formik>
    </>
  );
};
